module.exports = "<div [class.loader-hidden]=\"!show\" class=\"loader-block\">\r\n<div class=\"loader-overlay\">\r\n  <div class=\"loading-icon\">\r\n    <img src=\"assets/images/loader.gif\">\r\n    <span> {{'common.loading' | translate}}</span>\r\n\r\n  </div>\r\n</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/loader/loader.component.html
// module id = ../../../../../src/app/loader/loader.component.html
// module chunks = main